import { colors, darkThemeSelector, styled, zIndexes } from '@meterup/atto';
import React from 'react';

import { Drawer } from './Drawer';

const StageContainer = styled('div', {
  gridArea: 'stage',
  position: 'relative',
  zIndex: zIndexes.stage,
  display: 'grid',
  gridTemplateColumns: 'min-content 1fr min-content',
  gridTemplateRows: 'min-content 1fr',
  gridTemplateAreas: '"controls controls controls" "skimmer pane drawer"',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  backgroundColor: colors.bgApplicationLight,

  [darkThemeSelector]: {
    backgroundColor: colors.bgApplicationDark,
  },

  '@mobile': {
    strokeTop: colors.strokeNeutralLight,

    [darkThemeSelector]: {
      strokeTop: colors.strokeNeutralDark,
    },
  },

  '@notMobile': {
    strokeLeft: colors.strokeNeutralLight,

    [darkThemeSelector]: {
      strokeLeft: colors.strokeNeutralDark,
    },
  },
});
StageContainer.displayName = 'StageContainer';

export function Stage({
  breadcrumb,
  controls,
  skimmer,
  pane,
  drawer,
  drawerOpen = false,
}: {
  breadcrumb?: React.ReactNode;
  controls?: React.ReactNode;
  skimmer?: React.ReactNode;
  pane: React.ReactNode;
  drawer?: React.ReactNode;
  drawerOpen?: boolean;
}) {
  return (
    <StageContainer>
      {controls}
      {breadcrumb}
      {skimmer}
      {pane}
      <Drawer open={drawerOpen}>{drawer}</Drawer>
    </StageContainer>
  );
}
